export default __webpack_public_path__ + "static/media/back-icon.51b1bb91.svg";